import { render, staticRenderFns } from "./MA1.vue?vue&type=template&id=14e0bf31&scoped=true&"
import script from "./MA1.vue?vue&type=script&lang=js&"
export * from "./MA1.vue?vue&type=script&lang=js&"
import style0 from "./MA1.vue?vue&type=style&index=0&id=14e0bf31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e0bf31",
  null
  
)

export default component.exports